export default "__VITE_ASSET__D4RkD1Un__"